import { render, staticRenderFns } from "./scadacollectstat.vue?vue&type=template&id=2fe42820&scoped=true"
import script from "./scadacollectstat.vue?vue&type=script&lang=js"
export * from "./scadacollectstat.vue?vue&type=script&lang=js"
import style0 from "./scadacollectstat.vue?vue&type=style&index=0&id=2fe42820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe42820",
  null
  
)

export default component.exports